import React, { Component } from 'react'
import SvgComponent from '../../core/SvgComponent'
import SvgFile from './SvgFile'

class ProyugaLogoWhiteHeaderBeforeScroll extends Component {
  render() {
    return <SvgComponent renderComponent={SvgFile} {...this.props} />
  }
}

export { ProyugaLogoWhiteHeaderBeforeScroll }
